import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { InfoPanelSummaryDetails } from "~/components/AssetModal/shared/components/InfoPanel/components/InfoPanelSummaryDetails/InfoPanelSummaryDetails";
export const PublicInfoPanelSummary = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx(InfoPanelSummaryDetails, {});
});
PublicInfoPanelSummary.displayName = "PublicInfoPanelSummary";
